<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        absolute
        small
        fab
        top
        right
        class="filter-button"
        v-on="on"
        @click="myValue = !myValue"
      >
        <v-icon>{{ myValue ? 'mdi-filter-off' : 'mdi-filter-menu' }}</v-icon>
      </v-btn>
    </template>
    <span>
      {{ myValue ? $t('views.common.filterButton.close') : $t('views.common.filterButton.filter') }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    myValue: null,
  }),
  watch: {
    value: {
      handler() {
        this.myValue = this.value
      },
      immediate: true,
    },
    myValue() {
      this.$emit('input', this.myValue)
    },
  },
}
</script>

<style lang="scss">
.filter-button {
  margin-top: 4px;
  margin-right: 70px !important;
}
</style>